import styled from 'styled-components'

export const ConversationOrderSummaryThumbnailStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => props.theme.typography.pxToRem(40)};
  height: ${(props) => props.theme.typography.pxToRem(40)};
  background: ${(props) => props.theme.colors.content.contentBackground};
  border: 1px solid ${(props) => props.theme.colors.content.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
